import React from "react"
import PropTypes from "prop-types"
import { navigate } from "gatsby"
import {Consumer} from "../../libs/AuthContext"

const Authenticated = ({ component: Component, location, ...rest }) =>
  <Consumer>
  {context =>
        context.isAuthenticated
          ? <Component {...rest} />
          : navigate(`/login?redirect=${location.pathname}${location.search}`)

  }
  </Consumer>


Authenticated.propTypes = {
  component: PropTypes.any.isRequired,
}

export default Authenticated
